import React, {useEffect, useState} from 'react';
import {Link as RouterLink} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container, Grid} from '@mui/material'
import {ProjectCodeService} from '../../../../services';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {Check, X} from "react-feather";
import moment from 'moment';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const InvoiceTracker = () => {
    const [list, setList] = useState([]);
    const [checked, setChecked] = useState(false);
    const [loading, setLoading] = useState(true);
 

    const columns = [
      {
          field: 'projectId', headerName: 'Project Code', width: 200,
          renderCell: (params) => (
              <Link style={{textDecoration: 'none'}} component={RouterLink} to={'/integrations/onecp/projectCode/' + params.row.projectId}>
                  {params.value}
              </Link>
          )
      },
       {field: 'totalValue', headerName: 'Total Value', width: 200},      
       {field: 'source', headerName: 'Source', width: 200},   
       {field: 'extConfirmationNumber', headerName: 'ExtConf Number', width: 200},   
       {field: 'sentDate', headerName: 'Sent Date', width:200,  valueFormatter: params => 
          params.value ? moment(params?.value).format("DD/MM/YYYY hh:mm A") : '',},
       {field: 'isSent', headerName: 'Sent to CP', width: 200,  renderCell: (params) => (
                   <>{params.value === true ? <Check color='green'/> : <X color='red'/>}</>
               )}
  ]

          const checkHandler = (param) => {
            setLoading(true);
               setChecked(!checked);
               if(param === true){
                ProjectCodeService.getAll()
                .then((response) => {
                  setList(response.data);   
                  setLoading(false);              
              });    
               }else{
                ProjectCodeService.getById('not-sent')
                .then((response) => {
                  setList(response.data);      
                  setLoading(false);           
                    });
               }
            }
  
       useEffect(() => {
          ProjectCodeService.getById('not-sent')
         .then((response) => {
          setList(response.data);    
          setLoading(false);       
             
    });
       }, []);



        return (
            <React.Fragment>
                <Container>
                    <header>
                        <h1>Project/Budget Tracker</h1>
                    </header>
                  <FormControlLabel sx={{ m: 1}} control={<Checkbox
                                                         checked={checked}
                                                         onChange={() => { checkHandler(!checked)}}
                                                          inputProps={{ 'aria-label': 'controlled' }}
                                                       /> } label="View all" />    
                        <form>                            
                                <Grid container spacing={4}>
                                                
                                </Grid>                                                      
                              </form>
                              <Grid item xs={10}>&nbsp;</Grid>
                        <Grid item xs={12}>
                          {/* <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={35}
                               /> */}
                          <DataGrid     
                              autoHeight
                              rows={list}
                              columns={columns}
                              slots={{toolbar: GridToolbar}}
                              loading={loading}
                              disableColumnSelector                                    
                              disableVirtualization={false}
                              rowHeight={35}      
                              initialState={{
                                pagination: {
                                  paginationModel: { pageSize: 50, page: 0 },
                                },
                              }}
                              pagination
                              slotProps={{
                               toolbar: {
                                showQuickFilter: true ,
                                quickFilterProps: { debounceMs: 600 },
                                        },
                             }}
      />
                        </Grid>
                   
                </Container>
            </React.Fragment>
        );
}

export default InvoiceTracker;